import { useEffect } from "react";
import Swal from "sweetalert2";
import { getUrlParams } from "../helpers/setAndGetUrlParams";
import { useDispatch } from "react-redux";
import { setReloadAppInitializer } from "../../core/data/redux/commonSlice";

const useWaitForCompanyId = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let timeoutId;
    let intervalId;

    const companyId =
      getUrlParams("companyid") ||
      JSON.parse(localStorage.getItem("companyNameArr") || "[]")[0]?.value;

    // If companyId already exists, skip the Swal logic
    if (companyId) {
      dispatch(setReloadAppInitializer(false));
      return;
    }

    const handleCompanyIdReady = () => {
      const currentCompanyId = getUrlParams("companyid");
      if (currentCompanyId) {
        Swal.close();
        clearTimeout(timeoutId);
        clearInterval(intervalId);
      }
    };

    // Show loading dialog
    Swal.fire({
      title: "Setting up your account...",
      text: "Please wait while we set up your account.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // Timeout to show an error after 10 seconds
    timeoutId = setTimeout(() => {
      const currentCompanyId = getUrlParams("companyid");
      if (!currentCompanyId) {
        Swal.fire({
          icon: "error",
          title: "An error occurred",
          html: `
            <p>Please check your internet connection.</p>
            <button id="reload-btn" class="swal2-confirm swal2-styled" style="margin-top:10px;">Reload Page</button>
          `,
          showConfirmButton: false,
          didRender: () => {
            const reloadBtn = document.getElementById("reload-btn");
            if (reloadBtn) {
              reloadBtn.addEventListener("click", () => {
                dispatch(setReloadAppInitializer(true));
                window.location.reload();
              });
            }
          },
        });
      }
    }, 10000);

    // Interval to check if companyId becomes available
    intervalId = setInterval(handleCompanyIdReady, 300);

    // Cleanup
    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      Swal.close();
    };
  }, []);
};

export default useWaitForCompanyId;
